// extracted by mini-css-extract-plugin
export default {"tab":"TabsSecondary_tab__Ta1xU","icon":"TabsSecondary_icon__rwW6Z","focus":"TabsSecondary_focus__ly4Ti"};